import { FRAME_NAMES } from '@/common/define/apiTrace.define';
import { type SelectboxItem } from '@/common/utils';
import { getV7PostgresDatabaseList } from '@/api-client/postgresql/queries/postgresql-v7-controller/postgresql-v7-controller';
import type { ClusterDatabaseCmmRs } from '@/api-client/postgresql/model';
import { paExceptionHandler } from '@/common/utils/apiUtils';

export const fetchPostgresqlDatabaseList = async (
  instanceIds: string[],
): Promise<ClusterDatabaseCmmRs[]> => {
  try {
    if (!instanceIds?.length) {
      return [];
    }

    const {
      data: { data = [] },
    } = await getV7PostgresDatabaseList(
      { instanceIds },
      { params: { frameName: FRAME_NAMES.PA_ADDITIONAL.PG_DATABASE_LIST } },
    );

    return data || [];
  } catch (error: unknown) {
    paExceptionHandler({ error, isTempServerError: true });
    return [];
  }
};

export const getPostgresqlDatabaseList = async (
  instanceId: string, // PA => single instance only
): Promise<SelectboxItem<string>[]> => {
  const data = await fetchPostgresqlDatabaseList([instanceId]);

  const response = data.filter((item) => !!item.databaseList);
  if (!response.length) {
    return [];
  }

  return (response[0].databaseList || [])
    ?.filter(({ databaseName }) => !!databaseName)
    .map<SelectboxItem<string>>(({ databaseName }) => ({
      name: databaseName!,
      value: databaseName!,
      readonly: true,
    }));
};
